import { Component } from 'vue-property-decorator'
import Table from './table/index.vue'
import { Table as TableInterface } from '@interfaces/tables'
import MixinGame from '@mixins/game'
import { mixins } from 'vue-class-component'
import Auth from '@services/auth'

@Component({
  components: {
    'vgb-table': Table,
  },
})
export default class Tables extends mixins(MixinGame) {
  public tables: any[] = []
  public player: any = {}
  public isLeaving: boolean = false

  public logout () {
    Auth.logout()
    location.reload()
  }

  public async mounted () {
    this.tables = await this.$feathers.service('/api/seats').find() as any
    try {
      this.player = await this.$feathers.service('/api/players').get(Auth.userKey) as any
    } catch (e) {
      this.logout()
    }

    this.$feathers.service('/api/tables')
      .on('patched', (table) => {
        this.updateTable(table)

        if (!table.allSeatsTaken || table.status !== 'occupied') {
          return
        }

        const you = table.seats.find((seat: any) => {
          const player = seat.player
          return player.key === Auth.userKey
        })

        if (you) {
          this.updateTableID(table.id)
          this.$router.push('/game')
        }
      })

    this.$feathers.service('/api/seats')
      .on('patched', (table) => {
        this.updateTable(table)
      })
      .on('leave', ({ table }) => {
        this.updateTable(table)

        if (!table.allSeatsTaken && table.id === this.tableID) {
          this.leaveTable()
        }
      })
  }

  public leaveTable () {
    if (this.isLeaving) {
      return
    }

    this.$flits.error('Een speler heeft de tafel verlaten.')
    this.$flits.info('U wordt teruggestuurd naar het tafel overzicht')

    setTimeout(() => {
      this.isLeaving = false
      location.reload()
    }, 2000)

    this.isLeaving = true
  }

  public updateTable (table: TableInterface) {
    if (!table) {
      return
    }

    const tableIndex = this.tables.findIndex((t) => t.id === table.id)
    this.tables.splice(tableIndex, 1, table)
  }
}
